import { CalendarPlus } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  buildIcs,
  googleCalendarUrl,
  icsFileName,
  outlookCalendarUrl,
  type CalendarInvite,
} from "@/lib/calendar-invite";

export function AddToCalendar({
  invite,
  icsHref,
  label = "Add to calendar",
  variant = "outline",
  className,
}: {
  invite: CalendarInvite;
  /** Optional server-served .ics URL. Falls back to a client-generated file. */
  icsHref?: string | null;
  label?: string;
  variant?: "default" | "outline";
  className?: string;
}) {
  function downloadIcs() {
    if (icsHref) {
      window.location.href = icsHref;
      return;
    }
    const blob = new Blob([buildIcs(invite)], { type: "text/calendar;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = icsFileName(invite.title);
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant={variant} className={className}>
          <CalendarPlus className="mr-2 h-4 w-4" />
          {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        <DropdownMenuItem asChild>
          <a href={googleCalendarUrl(invite)} target="_blank" rel="noopener noreferrer">
            Google Calendar
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <a href={outlookCalendarUrl(invite)} target="_blank" rel="noopener noreferrer">
            Outlook
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => downloadIcs()}>
          Apple Calendar or other (.ics)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
